import React from 'react';
import Plane from '../SVGs/Plane';
import Calendar from '../SVGs/Calendar';
import Phone from '../SVGs/Phone';
import SMS from '../SVGs/SMS';
import WEB from '../SVGs/WEB';
import ProgressBar from './ProgressBar';

const BankUsageDetail = ({ usePercentage = '0', usageType = '', used = '', total = '', units = '', title = '' }) => {
  const determineIcon = (usageType) => {
    switch (usageType) {
      case 'Voice':
        return <Phone />;
      case 'Sms':
        return <SMS />;
      case 'Data':
        return <WEB />;
      case 'Calendar':
        return <Calendar />;
    }
  };

  const determineBg = (usageType) => {
    let parsed = parseInt(usePercentage);
    if (parsed < 75) {
      switch (usageType) {
        case 'Voice':
          return "var(--theme-primary, #9631ff)";
        case 'Sms':
          return "#c5a0ef";
        case 'Data':
          return " linear-gradient(to right, #8995fb 56%, #b382e2 103%)";
        case 'Calendar':
          return "linear-gradient(to right, #8995fb 66%, #b382e2 100%);";
      }
    } else {
      switch (usageType) {
        case 'Voice':
          return "#e74141";
        case 'Sms':
          return "#e74141";
        case 'Data':
          return " linear-gradient(to left, var(--theme-primary, #9631ff) 57%, #e74141 100%)";
        case 'Calendar':
          return "linear-gradient(to right, #8995fb 66%, #b382e2 100%);";
      }
    };
  }

  const determineTitle = (usageType) => {
    switch (usageType) {
      case 'Voice':
        return 'שיחות';
      case 'Sms':
        return 'SMS';
      case 'Data':
        return 'גלישה';
    }
  };

  const calcUsage = (usage) => {
    if (Number(usage) < 0.5 && Number(usage) > 0) {
      return '1';
    } else {
      let res = 0;
      if (Number(usage) >= 99 && Number(usage) < 100) {
        return '99';
      }
      res = Math.round(Number(usage));
      return res.toString();
    }
  };

  let detail = '';

  if (usageType == 'Calendar') {
    let parts1 = used.split('.'),
      parts2 = total.split('.');
    let start = new Date(parseInt(parts1[2], 10), parseInt(parts1[1], 10) - 1, parseInt(parts1[0], 10)),
      end = new Date(parseInt(parts2[2], 10), parseInt(parts2[1], 10) - 1, parseInt(parts2[0], 10)),
      today = new Date(),
      p = Math.round(((today - start) / (end - start)) * 100);
    if (p < 0) p = 0;
    detail = (
      <div className='BankUsage'>
        <div className='IconContainer'>{determineIcon(usageType)}</div>
        <div className='ProgressSection'>
          <div className='ProgressContainer'>
            <ProgressBar bgImage={' linear-gradient(to right, #8995fb 56%, #b382e2 103%)'} completed={p} isCalendar={true} />
          </div>
          <div className='BottomControls'>
            <span className='Title'>{used.replace(/\./g, '/')}</span>
            <span className='Percentage'>תקופת החבילה</span>
            <span className='Usage'>{total.replace(/\./g, '/')}</span>
          </div>
        </div>
      </div>
    );
  } else {
    const shouldDisplayFullData = !(
      title == 'גלישה לאפליקציות' &&
      ((parseInt(total) >= 900 && units.toUpperCase() == 'GB') || units.toUpperCase() == 'TB')
    );

    const percentageUsed = calcUsage(usePercentage);
    const percentageShow = shouldDisplayFullData ? (
      <span className='Percentage'>
        <b>{percentageUsed}%</b>
      </span>
    ) : (
      ''
    );
    const usageDisplay = shouldDisplayFullData ? (
      <span className='Usage'>
        \{total} {units}
      </span>
    ) : (
      <span className='Usage'>
        {used.includes('MB') ||
          used.includes('mb') ||
          used.includes('KB') ||
          used.includes('kb') ||
          used.includes('GB') ||
          used.includes('gb')
          ? null
          : units}
      </span>
    );
    detail = (
      <div className='BankUsage'>
        <div className='IconContainer'>{determineIcon(usageType)}</div>
        <div className='ProgressSection'>
          <div className='ProgressContainer'>
            <ProgressBar bgcolor={determineBg(usageType)} bgImage={determineBg(usageType)} completed={shouldDisplayFullData ? percentageUsed : '0'} />
          </div>
          <div className='BottomControls'>
            <span className='Title'>{title}</span>
            {percentageShow}
            <span className='Usage BoldUsage'>{used}</span>
            {usageDisplay}
          </div>
        </div>
      </div>
    );
  }
  return detail;
};

export default BankUsageDetail;
